module.exports = __webpack_public_path__ + "img/key-normal.f03f6790.png";